import { createAction } from '@reduxjs/toolkit';

export const setCategory = createAction('category/set');

export function setCategoryActionCreator(category) {
  return setCategory({ category });
}
